import React from 'react'

import BaseButton from '../base/base_button'

const WarningButton = props => (
	<BaseButton
		{...props}
		bgColor='red'
		fontColor='white' />
)

export default WarningButton
